import { useEffect, useRef } from 'react';

/**
 * Sets the document title and restores the original on unmount.
 * Pass null/undefined to leave the title unchanged.
 */
export function useDocumentTitle(title: string | null | undefined) {
  const originalRef = useRef<string>(document.title);

  useEffect(() => {
    if (title == null) return;
    const originalTitle = originalRef.current;
    document.title = title;
    return () => {
      document.title = originalTitle;
    };
  }, [title]);
}
